export default __webpack_public_path__ + "static/media/walks_768.6db7b3c1.webp";